<div [class.hidden]="!show">
    <div class="loader-overlay">
        <div *ngIf="show">
            <!-- <img src="../../../assets/images/loader.gif" alt=""> -->
            <div class="frame">
                <div class="center">
                   <div class="dot-1"></div>
                   <div class="dot-2"></div>
                   <div class="dot-3"></div>
                </div>
             </div>
        </div>
    </div>
</div>